class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification =
      document.getElementById('cart-notification');

    this.header =
      document.querySelector('sticky-header');

    this.onBodyClick =
      this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        'keyup',
        (evt) => {
          if (evt.code === 'Escape') {
            this.close();
          }
        }
      );
    }

    this.querySelectorAll(
      'button[type="button"]'
    ).forEach((closeButton) => {
      closeButton.addEventListener(
        'click',
        this.close.bind(this)
      );
    });
  }

  open() {
    if (!this.notification) {
      return;
    }

    this.notification.classList.add(
      'animate',
      'active'
    );

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener(
      'click',
      this.onBodyClick
    );
  }

  close() {
    if (!this.notification) {
      return;
    }

    this.notification.classList.remove(
      'active'
    );

    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.error(
        'Cart Notification: Invalid cart response',
        parsedState
      );
      return;
    }

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement =
        document.getElementById(section.id);

      // If target element does not exist, skip it
      if (!sectionElement) {
        console.warn(
          `Cart Notification: Element #${section.id} not found`
        );
        return;
      }

      const sectionHTML =
        parsedState.sections[section.id];

      // If Shopify did not return this section, skip it
      if (!sectionHTML) {
        console.warn(
          `Cart Notification: Section ${section.id} not found in response`
        );
        return;
      }

      const html =
        this.getSectionInnerHTML(
          sectionHTML,
          section.selector
        );

      // If selector was not found inside returned HTML, skip it
      if (html === null) {
        console.warn(
          `Cart Notification: Selector not found for ${section.id}`
        );
        return;
      }

      sectionElement.innerHTML = html;
    });

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) {
      return null;
    }

    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      parsedHTML.querySelector(selector);

    if (!element) {
      return null;
    }

    return element.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define(
  'cart-notification',
  CartNotification
);